import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/customer/:customerKey/portfolio',
    name: 'admin-customer-portfolio',
    component: () => import(/* webpackChunkName: "ctx-admin-customers" */ './CustomerPortfolioView.vue'),
    meta: {
        role: Role.APP_ADMIN,
        license: [],
        authenticated: true,
        settingsTabs: false,
        portfolioTabs: false,
        navbar: true,
        footer: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
